import React, { FunctionComponent } from 'react'

const Waffle: FunctionComponent = () => (
	<iframe
		className="waffle"
		width="728"
		height="300"
		title="Waffle"
		src="https://wafflegame.net/?embedded=true&minimal=true&theme=1a1a1b,454747,a9abad,d3d6da,ffffff,ffffff,f6f8fa"
	/>
)

export default Waffle
